import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    { path: '/', component: () => import('../pages/index') },
    { path: '/date', component: () => import('../pages/datelist') },
    { path: '/confirm', component: () => import('../pages/confirm') },
    { path: '/completed', component: () => import('../pages/completed') },
    { path: '/privacy', component: () => import('../pages/privacy') },
    { path: '/error', component: () => import('../pages/error') },
    { path: '*', component: () => import('../pages/error') }
]

const router = new VueRouter({
    routes,
    mode: "history"
});
  
export default router;